import axios from 'axios';

export const getTrades = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `trade`);
};
export const getTradesDetail = (trade_code: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `trade/` + trade_code
  );
};
export const GetById = (Id: number) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `trade/` + Id);
};
export const tradeUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `trade/update`, obj, {
    headers,
  });
};
export const tradeDelete = (obj: Object) => {
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `trade/delete`, obj);
};
export const tradeDeleteList = (List: Object[]) => {
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `trade/delete_list`,
    List
  );
};
export const createTrade = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `trade/add`, obj, {
    headers,
  });
};
